import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { useSidebar } from "./ui/sidebar";
interface LogoProps {
  className?: string;
}
export function Logo(t0) {
  const $ = _c(14);
  const {
    className
  } = t0;
  const {
    isMobile,
    state
  } = useSidebar();
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex h-16 items-center justify-center", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = state !== "collapsed" || isMobile ? "block" : "hidden";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("h-16 w-auto object-contain transition-opacity duration-200", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <img alt="Logo Agroproj" className={t3} decoding="async" height={64} loading="eager" src="/agroproj-logo-text.svg" width={160} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = state !== "collapsed" || isMobile ? "hidden" : "block";
  let t6;
  if ($[6] !== t5) {
    t6 = cn("h-12 w-auto object-contain transition-opacity duration-200", t5);
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <img alt="Logo Agroproj" className={t6} decoding="async" height={48} loading="eager" src="/agroproj-logo.svg" width={48} />;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t1 || $[11] !== t4 || $[12] !== t7) {
    t8 = <div className={t1}>{t4}{t7}</div>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}